<mat-dialog-content class="h-full">
  <div class="grid grid-col place-items-center items-center custom-font">
    <div class="mx-auto flex-1 flex-col place-items-center">

      <div class="mb-16 grid place-items-center">
        <div class="i-app-error"></div>
      </div>

      <div class="text-xl text-white font-semibold text-center mb-3">Błąd aplikacji</div>

      <div class="text-xs text-white text-center w-70">Spróbuj ponownie, jeśli błąd się powtórzy skontaktuj się z BOK
        tel. <a href="tel:+48609111114"><span class="text-white">+48 609 111 114</span></a>
      </div>

      <div *ngIf="error" class="my-3 text-xl text-white">{{error}}</div>

    </div>

    <button mat-flat-button color="primary" type="button"
            class=" flex justify-center items-center font-normal hover:font-normal"
            (click)="onSubmit()">
      <div class=" mx-6 text-sm text-white">Odśwież aplikację</div>
    </button>

  </div>
</mat-dialog-content>
